import { render, staticRenderFns } from "./CajaArtistasSeleccionados.vue?vue&type=template&id=81e1303a&scoped=true&"
import script from "./CajaArtistasSeleccionados.vue?vue&type=script&lang=js&"
export * from "./CajaArtistasSeleccionados.vue?vue&type=script&lang=js&"
import style0 from "./CajaArtistasSeleccionados.vue?vue&type=style&index=0&id=81e1303a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e1303a",
  null
  
)

export default component.exports